async function getGeolocaton() {
    if (!theme.settings.userLocation) {
        try {
            const request = await fetch('http://ipwhois.pro/json/?key=q26CUKSzFKfIPOXL');
            const data = await request.json();
            theme.settings.userLocation = data;
            return data;
        } catch (err) {
            console.error(err)
        }
    }
}